import { render, staticRenderFns } from "./DaftarRiwayat.vue?vue&type=template&id=98b6c0d0&scoped=true"
import script from "./DaftarRiwayat.vue?vue&type=script&lang=js"
export * from "./DaftarRiwayat.vue?vue&type=script&lang=js"
import style0 from "./DaftarRiwayat.vue?vue&type=style&index=0&id=98b6c0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6c0d0",
  null
  
)

export default component.exports